module.exports = __webpack_public_path__ + "img/real-likes.8985be9a.png";